import { Link } from "@bokio/elements/Link/Link";

import type { MouseEvent, ReactNode } from "react";

export interface SelectOptionProps<TValue> {
	labelWhenSelected: ReactNode;
	labelInDropDown: ReactNode;
	value: TValue;
	onClick?: (e: MouseEvent<HTMLAnchorElement>, value: TValue) => void;
	testId?: string;
}

const SelectOption = <TValue,>(props: SelectOptionProps<TValue>) => {
	const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
		if (props.onClick) {
			props.onClick(e, props.value);
		}
	};
	return (
		<Link onMouseDown={onClick} style="none" testId={props.testId}>
			{props.labelInDropDown}
		</Link>
	);
};

export default SelectOption;
